
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { i18nLanguage } from "../i18nLanguage.model";
import { Form } from "../Form.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class FormTranslation extends GenericEntityBase<string> {
  private _id?: string = undefined; 
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_Language}-${this.fK_Form}-${this.type}`; 
    }
    return this._id;
  }

  override _isRelationEntity = true;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Language!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Form!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  translation!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  type!: number;

  @NestedProperty({ TargetType: i18nLanguage })
  language?: i18nLanguage;

  @NestedProperty({ TargetType: Form })
  form?: Form;

  GetType(): IEntityMetaData {
    return FormTranslation.getMetaData();
  }
}
